'use strict';

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dec, _class2, _class3, _temp3;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

exports["default"] = function (props) {
  var isLegacy = props.config.imageManualLegacy;
  return isLegacy ? _react2["default"].createElement(_ImageManualLegacy2["default"], props) : _react2["default"].createElement(ImageManual, props);
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _v = require('uuid/v4');

var _v2 = _interopRequireDefault(_v);

var _reactKonva = require('react-konva');

var _ImageManualLegacy = require('./ImageManualLegacy');

var _ImageManualLegacy2 = _interopRequireDefault(_ImageManualLegacy);

var _shared = require('./shared');

var _LabelList = require('../components/LabelList');

var _LabelList2 = _interopRequireDefault(_LabelList);

var _LabelDropdown = require('../components/LabelDropdown');

var _LabelDropdown2 = _interopRequireDefault(_LabelDropdown);

var _Toolbar = require('../components/Toolbar');

var _util = require('../util');

var _constants = require('../constants');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = function styles(theme) {
  return {
    content: {
      '& .konvajs-content': {
        margin: [[0, 'auto']]
      }
    },
    wrapper: {
      width: '100%',
      height: '100%',
      overflow: 'hidden'
    },
    heading: {
      display: 'flex',
      textAlign: 'left'
    },
    shortcuts: {
      display: 'block',
      width: '100%',
      outline: 0
    },
    stage: {
      display: ['inline', '!important']
    },
    checkboxWrapper: {
      alignSelf: 'center',
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center'
    }
  };
};

var URLImage = function (_React$Component) {
  _inherits(URLImage, _React$Component);

  function URLImage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, URLImage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = URLImage.__proto__ || Object.getPrototypeOf(URLImage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      image: null
    }, _this.handleLoad = function () {
      _this.setState({
        image: _this.image
      });

      _this.imageNode.getLayer().batchDraw();

      if (_this.props.onLoad) {
        _this.props.onLoad(_this.image);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(URLImage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.loadImage();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(oldProps) {
      if (oldProps.src !== this.props.src) {
        this.loadImage();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.image.removeEventListener('load', this.handleLoad);
    }
  }, {
    key: 'loadImage',
    value: function loadImage() {
      this.image = new window.Image();
      this.image.src = this.props.src;
      this.image.addEventListener('load', this.handleLoad);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2["default"].createElement(_reactKonva.Image, {
        x: this.props.x,
        y: this.props.y,
        opacity: this.props.opacity,
        image: this.state.image,
        ref: function ref(node) {
          _this2.imageNode = node;
        }
      });
    }
  }]);

  return URLImage;
}(_react2["default"].Component);

function getShape(node) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'shape'; // Get the shape of a node (group or not)

  return node.name() === name ? node : node.getChildren(function (node) {
    return node.name() === name;
  })[0];
}

function getLabelPos(span) {
  if (span.type === 'rect') {
    return {
      x: span.width >= 0 ? span.x : span.x + span.width,
      y: span.height >= 0 ? span.y : span.y + span.height
    };
  } else {
    var highest = [].concat(_toConsumableArray(span.points)).sort(function (a, b) {
      return a[1] - b[1];
    })[0];
    return {
      x: highest[0],
      y: highest[1]
    };
  }
}

function getLinePoints(points, x, y, isDrawn) {
  var flatPoints = (0, _util.flattenArray)(points);

  if (isDrawn && [x, y].every(function (pos) {
    return typeof pos !== 'undefined' && pos !== null;
  })) {
    return [].concat(_toConsumableArray(flatPoints), [x, y]);
  }

  return flatPoints;
}

function filterDuplicatePoints(points) {
  // Handle a bug (?) from previous versions that'd cause polygons to receive
  // duplicate points, e.g. [[a, b], [a, b], [c, d], [c, d]]
  return points.map(function (_ref2, i) {
    var _ref3 = _slicedToArray(_ref2, 2),
        x = _ref3[0],
        y = _ref3[1];

    if (i === 0) return [x, y];

    var _points = _slicedToArray(points[i - 1], 2),
        prevX = _points[0],
        prevY = _points[1];

    return x === prevX && y === prevY ? null : [x, y];
  }).filter(function (p) {
    return p;
  });
}

var Shape = _react2["default"].forwardRef(function (props, ref) {
  var children = props.children,
      span = props.span,
      _props$name = props.name,
      name = _props$name === undefined ? 'shape' : _props$name,
      draggable = props.draggable,
      currentColor = props.currentColor,
      strokeWidth = props.strokeWidth,
      fontSize = props.fontSize,
      pixel = props.pixel,
      showLabel = props.showLabel,
      handleDragEnd = props.handleDragEnd,
      handleDragStart = props.handleDragStart,
      handlePointClick = props.handlePointClick,
      handleDragPoint = props.handleDragPoint,
      closed = props.closed,
      pointHover = props.pointHover,
      setPointHover = props.setPointHover,
      drawing = props.drawing,
      isSelected = props.isSelected,
      showPoints = props.showPoints,
      showCenter = props.showCenter,
      theme = props.theme,
      isDrawn = props.isDrawn,
      x = props.x,
      y = props.y,
      other = _objectWithoutProperties(props, ['children', 'span', 'name', 'draggable', 'currentColor', 'strokeWidth', 'fontSize', 'pixel', 'showLabel', 'handleDragEnd', 'handleDragStart', 'handlePointClick', 'handleDragPoint', 'closed', 'pointHover', 'setPointHover', 'drawing', 'isSelected', 'showPoints', 'showCenter', 'theme', 'isDrawn', 'x', 'y']);

  var color = span.color || currentColor;

  var shapeProps = _extends({
    name: name,
    ref: ref,
    stroke: color,
    strokeWidth: strokeWidth,
    strokeScaleEnabled: false,
    fill: isSelected ? (0, _util.getAlphaColor)(color, 0.3) : 'transparent'
  }, other);

  var centerLineProps = {
    strokeWidth: Math.max(strokeWidth / 2, 1),
    stroke: color
  };
  var centerLineA = [span.x, span.y, span.x + span.width, span.y + span.height];
  var centerLineB = [span.x + span.width, span.y, span.x, span.y + span.height];
  var onDragEnd = handleDragEnd(span);
  var onDragStart = handleDragStart(span);
  var onPointClick = handlePointClick;
  var isDraggable = draggable && !pointHover;
  var pointsVisible = span.type !== 'freehand' && (showPoints || isDrawn);

  var handlePointMouseDown = function handlePointMouseDown(isFirst, isLast) {
    return function (event) {
      if (drawing && isLast) {
        event.cancelBubble = true;
      }

      if (drawing && isFirst) onPointClick(event);
    };
  };

  return _react2["default"].createElement(_react.Fragment, null, _react2["default"].createElement(_reactKonva.Group, {
    draggable: isDraggable,
    onDragStart: isDraggable ? onDragStart : null,
    onDragEnd: isDraggable ? onDragEnd : null
  }, span.type === 'rect' ? _react2["default"].createElement(_react.Fragment, null, _react2["default"].createElement(_reactKonva.Rect, _extends({}, shapeProps, {
    x: span.x,
    y: span.y,
    width: span.width,
    height: span.height
  })), showCenter && isSelected && !drawing && showPoints && _react2["default"].createElement(_react.Fragment, null, _react2["default"].createElement(_reactKonva.Line, _extends({
    points: centerLineA
  }, centerLineProps)), _react2["default"].createElement(_reactKonva.Line, _extends({
    points: centerLineB
  }, centerLineProps)))) : _react2["default"].createElement(_react.Fragment, null, _react2["default"].createElement(_reactKonva.Line, _extends({
    points: getLinePoints(span.points, x, y, isDrawn)
  }, shapeProps, {
    closed: closed // We don't want edges to poke out from points, but
    // if no points are there, shape should be drawn sharply
    ,
    lineJoin: pointsVisible ? 'round' : 'miter',
    lineCap: 'round' // NB: using tension for freehand messes up transformer

  })), pointsVisible && span.points.map(function (_ref4, i) {
    var _ref5 = _slicedToArray(_ref4, 2),
        x = _ref5[0],
        y = _ref5[1];

    var pointId = span.id + '-' + i;
    var isHover = pointHover === pointId;
    var radiusFactor = isHover ? 2 : 1.5;
    var radius = Math.max(strokeWidth * pixel, 3);
    var isFirst = i === 0;
    var isLast = i === span.points.length - 1;
    return _react2["default"].createElement(_reactKonva.Circle, {
      key: i,
      x: x,
      y: y,
      fill: color,
      radius: radius * radiusFactor,
      onMouseOver: function onMouseOver() {
        if (!drawing || isFirst) setPointHover(pointId);
      },
      onMouseOut: function onMouseOut() {
        return setPointHover(null);
      },
      onMouseDown: handlePointMouseDown(isFirst, isLast),
      onDragMove: handleDragPoint(span, i),
      onTouchStart: handlePointMouseDown(isFirst, isLast),
      draggable: pointHover,
      listening: !drawing || !isLast
    });
  })), children));
});

var ShapeLabel = function ShapeLabel(props) {
  var span = props.span,
      strokeWidth = props.strokeWidth,
      pixel = props.pixel,
      theme = props.theme,
      fontSize = props.fontSize,
      other = _objectWithoutProperties(props, ['span', 'strokeWidth', 'pixel', 'theme', 'fontSize']);

  var labelPos = getLabelPos(span);
  return _react2["default"].createElement(_reactKonva.Group, {
    name: 'label'
  }, _react2["default"].createElement(_reactKonva.Label, _extends({
    x: labelPos.x,
    y: labelPos.y - strokeWidth / 2 * pixel
  }, other), _react2["default"].createElement(_reactKonva.Tag, {
    fill: span.color
  }), _react2["default"].createElement(_reactKonva.Text, {
    text: span.label,
    fontFamily: theme.fontSecondary,
    fontSize: fontSize,
    fontStyle: 'bold',
    padding: fontSize * 0.2,
    fill: (0, _util.getContrastColor)(span.color)
  })));
};

var ImageManual = (_dec = (0, _util.withStyles)(styles, {
  withTheme: true
}), _dec(_class2 = (_temp3 = _class3 = function (_React$Component2) {
  _inherits(ImageManual, _React$Component2);

  function ImageManual() {
    var _ref6;

    var _temp2, _this3, _ret2;

    _classCallCheck(this, ImageManual);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this3 = _possibleConstructorReturn(this, (_ref6 = ImageManual.__proto__ || Object.getPrototypeOf(ImageManual)).call.apply(_ref6, [this].concat(args))), _this3), _this3.keymap = 'IMAGE', _this3.state = {
      label: '',
      modes: ['rect', 'polygon'],
      mode: 'rect',
      showAll: true,
      showLabels: true,
      spans: [],
      origSpans: [],
      current: [],
      drawing: false,
      selected: null,
      hover: null,
      pointHover: null,
      pixel: 1,
      strokeWidth: 4,
      fontSize: 16,
      fromCenter: false,
      keepRatio: false,
      selectKey: false // Used to store refs to the boxes to attach transformer to

    }, _this3.spans = {}, _this3.resetState = {
      x: null,
      y: null,
      current: {},
      selected: null,
      drawing: false,
      isDragged: false,
      isTransforming: false,
      selectKey: false
    }, _this3.componentWillMount = function () {
      var config = _this3.props.config;

      _this3.setState({
        modes: config.imageManualModes,
        mode: config.imageManualModes[0],
        strokeWidth: config.imageManualStrokeWidth,
        fontSize: config.imageManualFontSize,
        minFontSize: config.imageManualFontSize,
        fromCenter: config.imageManualFromCenter,
        showCenter: config.showCenter,
        showLabels: config.imageManualShowLabels
      });
    }, _this3.componentDidMount = function () {
      var _this3$props = _this3.props,
          content = _this3$props.content,
          config = _this3$props.config;

      _this3.updateBoxes(content);

      if (config.labels && config.labels.length) {
        _this3.setState({
          label: config.labels[0]
        });
      }

      if (_this3.context.shortcuts) {
        var selectKey = (0, _util.getKeyName)(_this3.context, _this3.keymap, 'select').toLowerCase();
        var ratioKey = (0, _util.getKeyName)(_this3.context, _this3.keymap, 'ratio').toLowerCase();
        document.body.addEventListener('keydown', function (event) {
          _this3.keypressToState(event.key, selectKey, 'selectKey', true);

          _this3.keypressToState(event.key, ratioKey, 'keepRatio', true);
        });
        document.body.addEventListener('keyup', function (event) {
          _this3.keypressToState(event.key, selectKey, 'selectKey', false);

          _this3.keypressToState(event.key, ratioKey, 'keepRatio', false);
        });
      }
    }, _this3.componentDidUpdate = function (prev) {
      var content = _this3.props.content;

      if (prev.content && prev.content[_constants.TASK_ID] !== content[_constants.TASK_ID]) {
        _this3.updateBoxes(content);
      }
    }, _this3.keypressToState = function (pressed, key, stateKey, value) {
      if (pressed.toLowerCase() === key) {
        // User holds down or releases the key
        _this3.setState(_defineProperty({}, stateKey, value));
      }
    }, _this3.handleImageLoad = function (image) {
      var width = image.naturalWidth;
      var height = image.naturalHeight;

      if (!_this3.props.content.width || !_this3.props.content.height) {
        _this3.props.update({
          width: width,
          height: height
        });
      } // calculate bounding box sizes based on image dimensions


      var minWidth = _this3.props.minWidth;
      var minFontSize = _this3.state.minFontSize;
      var fontSize = Math.max(minFontSize, minFontSize / minWidth * width);
      var pixel = Math.max(1, 1 / minWidth * width);
      var contentWidth = _this3.content ? _this3.content.clientWidth : minWidth;

      _this3.setState({
        width: width,
        height: height,
        fontSize: fontSize,
        contentWidth: contentWidth,
        pixel: pixel
      });
    }, _this3.isRect = function (span) {
      return [span.x, span.y, span.width, span.height].every(function (v) {
        return typeof v !== 'undefined' && v !== null;
      });
    }, _this3.isPointsRect = function (span) {
      var points = span.points;
      if (!points || points.length !== 4) return false;
      if (points[0][0] !== points[1][0]) return false;
      if (points[0][1] !== points[3][1]) return false;
      if (points[1][1] !== points[2][1]) return false;
      if (points[2][0] !== points[3][0]) return false;
      var _arr = [span.x, span.y, span.width, span.height];

      for (var _i = 0; _i < _arr.length; _i++) {
        var prop = _arr[_i];

        if (typeof prop === 'undefined' || prop === null) {
          return true;
        }
      }

      return false;
    }, _this3.updateBoxes = function (_ref7) {
      var _ref7$spans = _ref7.spans,
          spans = _ref7$spans === undefined ? [] : _ref7$spans;
      var newSpans = spans.map(function (span, i) {
        var newSpan = _extends({}, span, {
          color: span.color || _this3.getColor(span.label, i),
          id: span.id || (0, _v2["default"])()
        });

        if (_this3.isPointsRect(span)) {
          // We have a rectangle consisting of only points
          var rect = (0, _util.pointsToRect)([span.points[0], span.points[2]]);
          var center = (0, _util.getCenter)(rect);
          newSpan = _extends({}, newSpan, rect, {
            center: center,
            type: newSpan.type || 'rect'
          });
        } else if (_this3.isRect(span)) {
          // We have a rect with x/y/width/height and no points
          var _center = (0, _util.getCenter)(span);

          var points = span.points || (0, _util.rectToPoints)(span);
          newSpan = _extends({}, newSpan, {
            points: points,
            center: _center,
            type: newSpan.type || 'rect'
          });
        } else {
          var _points2 = filterDuplicatePoints(newSpan.points);

          newSpan = _extends({}, newSpan, {
            points: _points2,
            type: newSpan.type || 'polygon'
          });
        }

        return newSpan;
      });

      _this3.setState({
        origSpans: newSpans,
        spans: newSpans,
        current: {},
        drawing: false,
        selected: null
      });
    }, _this3.selectSpan = function (span) {
      var drawing = _this3.state.drawing;
      if (drawing) return;

      _this3.setState({
        selected: span.id,
        label: span.label
      }, function () {
        _this3.trf.setNode(_this3.spans[span.id]);
      });
    }, _this3.handleLabelSelect = function (label) {
      var _this3$state = _this3.state,
          selected = _this3$state.selected,
          spans = _this3$state.spans;

      _this3.setState({
        label: label
      });

      if (selected) {
        var selectedIndex = spans.map(function (s) {
          return s.id;
        }).indexOf(selected);

        var color = _this3.getColor(label, selectedIndex);

        _this3.updateSpan(selected, {
          label: label,
          color: color
        });
      }
    }, _this3.handleDelete = function () {
      var _this3$state2 = _this3.state,
          selected = _this3$state2.selected,
          spans = _this3$state2.spans;
      var newSpans = selected ? spans.filter(function (s) {
        return s.id !== selected;
      }) : spans;

      _this3.setState(_extends({
        spans: newSpans
      }, _this3.resetState));

      _this3.props.update({
        spans: newSpans
      });
    }, _this3.handleReset = function () {
      var newSpans = _this3.state.origSpans;

      _this3.setState(_extends({
        spans: newSpans
      }, _this3.resetState));

      _this3.props.update({
        spans: newSpans
      });
    }, _this3.handleMouseDown = function (event) {
      var _this3$state3 = _this3.state,
          mode = _this3$state3.mode,
          current = _this3$state3.current,
          selected = _this3$state3.selected,
          pointHover = _this3$state3.pointHover;
      var pt = (0, _util.getRelativePointerPosition)(event.target.getStage());
      var x = (0, _util.roundPx)(pt.x);
      var y = (0, _util.roundPx)(pt.y); // Don't draw if we're resizing a polygon point

      if (pointHover) return; // Check if the click is on another shape. If so, don't start drawing

      var targetName = event.target.attrs.name;

      if (targetName && (targetName == 'shape' || targetName.indexOf('anchor') !== -1)) {
        return;
      }

      if (mode !== 'rect') {
        if (selected !== null) {
          // Another shape is selected, don't start drawing yet, just unselect
          _this3.setState({
            selected: null
          });

          return;
        } // We're inside a polygon / freehand here


        var prevPoints = current.points || [];

        if (prevPoints.length >= 1) {
          var _prevPoints = _slicedToArray(prevPoints[prevPoints.length - 1], 2),
              prevX = _prevPoints[0],
              prevY = _prevPoints[1]; // Don't add duplicate points


          if (prevX === x && prevY === y) return;
        }

        var points = [].concat(_toConsumableArray(prevPoints), [[x, y]]);

        var newCurrent = _extends({}, current, {
          points: points,
          type: mode
        });

        _this3.setState({
          drawing: true,
          selected: null,
          current: newCurrent
        });
      } else {
        var _current = {
          x: x,
          y: y,
          height: 0,
          width: 0,
          center: [x, y],
          type: mode
        };

        _this3.setState({
          drawing: true,
          current: _current
        });
      }
    }, _this3.handleMouseMove = function (event) {
      var _this3$state4 = _this3.state,
          drawing = _this3$state4.drawing,
          current = _this3$state4.current,
          fromCenter = _this3$state4.fromCenter,
          keepRatio = _this3$state4.keepRatio;

      if (!drawing) {
        return;
      }

      var pt = (0, _util.getRelativePointerPosition)(event.target.getStage());
      var x = (0, _util.roundPx)(pt.x);
      var y = (0, _util.roundPx)(pt.y);

      _this3.setState({
        x: x,
        y: y
      });

      if (current.type === 'rect') {
        var _current$center = _slicedToArray(current.center, 2),
            centerX = _current$center[0],
            centerY = _current$center[1];

        var best = Math.max(Math.abs(x - current.x), Math.abs(y - current.y));
        var bestWidth = x < current.x ? -best : best;
        var bestHeight = y < current.y ? -best : best;
        var width = fromCenter ? (x - centerX) * 2 : keepRatio ? bestWidth : x - current.x;
        var height = fromCenter ? (y - centerY) * 2 : keepRatio ? bestHeight : y - current.y;
        var newX = fromCenter ? centerX - width / 2 : current.x;
        var newY = fromCenter ? centerY - height / 2 : current.y;
        var rect = {
          x: newX,
          y: newY,
          width: width,
          height: height
        };
        var center = fromCenter ? current.center : (0, _util.getCenter)(rect);
        var points = [[newX, newY], keepRatio ? [newX + width, newY + height] : [x, y]];

        _this3.setState({
          current: _extends({}, current, rect, {
            center: center,
            points: points
          })
        });
      } else if (current.type === 'freehand') {
        var updates = {
          points: [].concat(_toConsumableArray(current.points), [[x, y]])
        };

        _this3.setState({
          current: _extends({}, current, updates)
        });
      }
    }, _this3.handleMouseUp = function (event) {
      // Finished clicking or clicking and dragging. Here we only want to
      // stop drawing and lock in a final shape if we're dragging a rect, not
      // if we're adding polygon points via click.
      var _this3$state5 = _this3.state,
          current = _this3$state5.current,
          drawing = _this3$state5.drawing,
          keepRatio = _this3$state5.keepRatio;

      if (!drawing) {
        return;
      }

      if (current.type === 'rect') {
        // The rect drawn has no width or height and was created in a single click
        if (current.width === 0 || current.height === 0) {
          _this3.setState(_this3.resetState);

          return;
        } // Re-create the rect and fix negaitve widths and heights (doing it
        // here to not interfere with x/y during drawing)


        var finalRect = (0, _util.pointsToRect)(current.points);
        var finalPoints = (0, _util.rectToPoints)(finalRect);

        _this3.setState(_this3.resetState);

        _this3.addSpan(_extends({}, current, finalRect, {
          points: finalPoints
        }));
      } else if (current.type === 'freehand') {
        _this3.handleClosePoints();
      }
    }, _this3.handleClosePoints = function (event) {
      var _this3$state6 = _this3.state,
          drawing = _this3$state6.drawing,
          current = _this3$state6.current;

      if (drawing && current.type !== 'rect') {
        if (current.points.length <= 2) return; // We're still drawing the polygon, close the shape

        _this3.addSpan(current);

        _this3.setState(_this3.resetState);
      }
    }, _this3.handleDragStart = function (span) {
      return function (event) {
        _this3.setState({
          isDragged: span.id
        });
      };
    }, _this3.handleDragEnd = function (span) {
      return function (event) {
        if (!_this3.state.isDragged) return;

        _this3.setState({
          isDragged: null
        });

        _this3.updateSpan(span.id, _this3.getDimensions(span, event.target));
      };
    }, _this3.handleDragPoint = function (span, idx) {
      return function (event) {
        var pt = (0, _util.getRelativePointerPosition)(event.target.getStage());
        var x = (0, _util.roundPx)(pt.x);
        var y = (0, _util.roundPx)(pt.y);
        var points = span.points.map(function (p, i) {
          return i === idx ? [x, y] : p;
        });

        _this3.updateSpan(span.id, {
          points: points
        });
      };
    }, _this3.handleSelectSpan = function (span) {
      return function (event) {
        event.cancelBubble = true;

        _this3.selectSpan(span);
      };
    }, _this3.getDimensions = function (span, node) {
      // Get the new position of a node after dragging, resizing etc.
      var scaleX = node.scaleX();
      var scaleY = node.scaleY();
      var x = (0, _util.roundPx)(node.x());
      var y = (0, _util.roundPx)(node.y()); // Reset those relative (!) values of the *actual* shape

      node.scaleX(1);
      node.scaleY(1);
      node.x(0);
      node.y(0);

      if (span.type === 'rect') {
        var isResize = node.name() === 'shape';
        var rect = {
          x: isResize ? x : (0, _util.roundPx)(span.x * scaleX + x),
          y: isResize ? y : (0, _util.roundPx)(span.y * scaleY + y),
          width: (0, _util.roundPx)(span.width * scaleX),
          height: (0, _util.roundPx)(span.height * scaleY)
        };

        if (isResize) {
          node.x(rect.x);
          node.y(rect.y);
        }

        return _extends({}, rect, {
          points: (0, _util.rectToPoints)(rect),
          center: (0, _util.getCenter)(rect)
        });
      } else {
        var points = span.points.map(function (p) {
          return [(0, _util.roundPx)(p[0] * scaleX + x), (0, _util.roundPx)(p[1] * scaleY + y)];
        });
        var line = getShape(node);
        line.points((0, _util.flattenArray)(points));
        return {
          points: points
        };
      }
    }, _this3.addSpan = function (span) {
      // Add a new span to the canvas
      var _this3$state7 = _this3.state,
          spans = _this3$state7.spans,
          label = _this3$state7.label;

      var color = _this3.getColor(label, spans.length);

      var newSpan = _extends({
        id: (0, _v2["default"])(),
        label: label,
        color: color
      }, span);

      var newSpans = [].concat(_toConsumableArray(spans), [newSpan]);

      _this3.setState({
        spans: newSpans
      });

      _this3.props.update({
        spans: newSpans
      });
    }, _this3.updateSpan = function (spanId, updates) {
      // Update an existing span
      var spans = _this3.state.spans;
      var index = spans.map(function (span) {
        return span.id;
      }).indexOf(spanId);
      var current = spans.find(function (s) {
        return s.id == spanId;
      });
      var prevSpans = spans.filter(function (s) {
        return s.id !== spanId;
      });

      var newSpan = _extends({}, current, updates); // Insert new span at its old position so index for color etc. matches


      var newSpans = (0, _util.insertInto)(prevSpans, newSpan, index);

      _this3.setState({
        spans: newSpans
      });

      _this3.props.update({
        spans: newSpans
      });
    }, _this3.handlePixelMove = function (dir) {
      var _this3$state8 = _this3.state,
          selected = _this3$state8.selected,
          spans = _this3$state8.spans,
          pixel = _this3$state8.pixel;
      if (!selected) return;
      var current = spans.find(function (span) {
        return span.id == selected;
      });

      if (current.type === 'rect') {
        var rect = _extends({}, current);

        if (dir === 'left') rect.x = rect.x - 1;else if (dir === 'right') rect.x = rect.x + 1;else if (dir === 'up') rect.y = rect.y - 1;else if (dir === 'down') rect.y = rect.y + 1;
        var center = (0, _util.getCenter)(rect);
        var points = (0, _util.rectToPoints)(rect);

        _this3.updateSpan(selected, _extends({}, rect, {
          center: center,
          points: points
        }));
      } else {
        var _points3 = [].concat(_toConsumableArray(current.points));

        if (dir === 'left') _points3 = _points3.map(function (_ref8) {
          var _ref9 = _slicedToArray(_ref8, 2),
              x = _ref9[0],
              y = _ref9[1];

          return [x - pixel, y];
        });else if (dir === 'right') _points3 = _points3.map(function (_ref10) {
          var _ref11 = _slicedToArray(_ref10, 2),
              x = _ref11[0],
              y = _ref11[1];

          return [x + pixel, y];
        });else if (dir === 'up') _points3 = _points3.map(function (_ref12) {
          var _ref13 = _slicedToArray(_ref12, 2),
              x = _ref13[0],
              y = _ref13[1];

          return [x, y - pixel];
        });else if (dir === 'down') _points3 = _points3.map(function (_ref14) {
          var _ref15 = _slicedToArray(_ref14, 2),
              x = _ref15[0],
              y = _ref15[1];

          return [x, y + pixel];
        });

        _this3.updateSpan(selected, {
          points: _points3
        });
      }
    }, _this3.handleTrfStart = function (span) {
      return function () {
        _this3.setState({
          isTransforming: span.id
        });
      };
    }, _this3.handleTrfEnd = function (span) {
      return function (event) {
        _this3.setState({
          isTransforming: null
        });

        _this3.updateSpan(span.id, _this3.getDimensions(span, event.target));
      };
    }, _this3.changeMode = function (mode) {
      _this3.setState({
        mode: mode,
        selected: null
      });
    }, _this3.changeShowLabels = function () {
      _this3.setState({
        showLabels: !_this3.state.showLabels
      });
    }, _this3.sortSpans = function (spans) {
      var selected = _this3.state.selected;
      if (selected === null) return spans;
      var current = spans.find(function (s) {
        return s.id == selected;
      });
      var other = spans.filter(function (s) {
        return s.id !== selected;
      });
      return [].concat(_toConsumableArray(other), [current]);
    }, _this3.getColor = function (label, i) {
      var labelColors = _this3.props.config.labelColors;
      return labelColors[label] || (0, _util.getColor)(_constants.BOX_COLORS, i);
    }, _this3.getCursor = function () {
      var _this3$state9 = _this3.state,
          hover = _this3$state9.hover,
          pointHover = _this3$state9.pointHover,
          selected = _this3$state9.selected,
          drawing = _this3$state9.drawing,
          mode = _this3$state9.mode;
      if (drawing && pointHover) return 'pointer';
      if (!drawing && pointHover) return 'move';
      if (hover !== null && hover === selected) return 'grab';
      if (hover !== null && !drawing) return 'pointer';
      if (mode === 'freehand') return 'default';
      return 'crosshair';
    }, _this3.handleShortcuts = function (action, ev) {
      switch (action) {
        case 'rect':
          if (_this3.state.modes.includes('rect')) {
            _this3.setState({
              mode: 'rect'
            });
          }

          break;

        case 'polygon':
          if (_this3.state.modes.includes('polygon')) {
            _this3.setState({
              mode: 'polygon'
            });
          }

          break;

        case 'freehand':
          if (_this3.state.modes.includes('freehand')) {
            _this3.setState({
              mode: 'freehand'
            });
          }

          break;

        case 'labels':
          _this3.changeShowLabels();

          break;

        case 'reset':
          _this3.handleReset();

          break;

        case 'delete':
          _this3.handleDelete();

          break;

        case 'exit':
          if (_this3.state.drawing) _this3.handleDelete();else _this3.setState({
            selected: null
          });
          break;

        case 'left':
          _this3.handlePixelMove('left');

          break;

        case 'right':
          _this3.handlePixelMove('right');

          break;

        case 'up':
          _this3.handlePixelMove('up');

          break;

        case 'down':
          _this3.handlePixelMove('down');

          break;
      }
    }, _temp2), _possibleConstructorReturn(_this3, _ret2);
  } // State used to reset current drawing board


  _createClass(ImageManual, [{
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          content = _props.content,
          config = _props.config,
          ToolbarButton = _props.ToolbarButton,
          classes = _props.classes,
          theme = _props.theme,
          anchorSize = _props.anchorSize,
          translate = _props.translate;
      var labels = config.labels,
          labelStyle = config.labelStyle,
          darkenImage = config.darkenImage;
      var darkenOpacity = 1 - darkenImage;
      var _state = this.state,
          mode = _state.mode,
          modes = _state.modes,
          selected = _state.selected,
          label = _state.label,
          spans = _state.spans,
          current = _state.current,
          origSpans = _state.origSpans,
          contentWidth = _state.contentWidth,
          fontSize = _state.fontSize,
          pixel = _state.pixel,
          isTransforming = _state.isTransforming,
          isDragged = _state.isDragged,
          hover = _state.hover,
          pointHover = _state.pointHover,
          drawing = _state.drawing,
          strokeWidth = _state.strokeWidth,
          fromCenter = _state.fromCenter,
          showCenter = _state.showCenter,
          showLabels = _state.showLabels,
          x = _state.x,
          y = _state.y,
          selectKey = _state.selectKey,
          keepRatio = _state.keepRatio;
      var sortedSpans = this.sortSpans(spans);
      var LabelComponent = labelStyle == 'dropdown' ? _LabelDropdown2["default"] : _LabelList2["default"];
      var currentColor = this.getColor(label, spans.length);

      var transformerProps = _defineProperty({
        rotateEnabled: false,
        anchorStrokeWidth: 0,
        anchorSize: anchorSize,
        anchorCornerRadius: 5,
        keepRatio: false,
        borderStrokeWidth: Math.max(strokeWidth / 2, 2),
        borderDash: [2, 3],
        centeredScaling: fromCenter
      }, 'keepRatio', keepRatio);

      var scale = content.width > contentWidth ? contentWidth / content.width : 1;
      var shapeProps = {
        showCenter: showCenter,
        strokeWidth: strokeWidth,
        fontSize: fontSize,
        pixel: pixel,
        theme: theme,
        currentColor: currentColor,
        drawing: drawing,
        pointHover: pointHover,
        setPointHover: function setPointHover(val) {
          return _this4.setState({
            pointHover: val
          });
        },
        handlePointClick: function handlePointClick() {
          return _this4.handleClosePoints();
        },
        handleDragPoint: this.handleDragPoint,
        handleDragEnd: this.handleDragEnd,
        handleDragStart: this.handleDragStart,
        x: x,
        y: y
      };
      var shapeLabelProps = {
        strokeWidth: strokeWidth,
        fontSize: fontSize,
        pixel: pixel,
        theme: theme
      };
      var width = content.width * scale;
      var height = content.height * scale;

      var toolbar = _react2["default"].createElement(_util.ShortcutsWrapper, {
        ctx: this.context.shortcuts,
        className: classes.shortcuts,
        name: this.keymap,
        handler: this.handleShortcuts,
        targetNodeSelector: 'body',
        global: true
      }, _react2["default"].createElement(_Toolbar.Toolbar, null, _react2["default"].createElement('div', {
        className: classes.checkboxWrapper
      }, modes.map(function (m) {
        return _react2["default"].createElement(ToolbarButton, {
          key: m,
          id: m,
          active: mode == m,
          onClick: function onClick() {
            return _this4.changeMode(m);
          },
          keyName: (0, _util.getKeyName)(_this4.context, _this4.keymap, m),
          title: translate('image_' + m, m)
        });
      }), _react2["default"].createElement(_Toolbar.ToolbarCheckbox, {
        checked: showLabels,
        onChange: this.changeShowLabels,
        label: translate('show_all_labels', 'All labels'),
        disabled: !spans.length,
        keyName: (0, _util.getKeyName)(this.context, this.keymap, 'labels')
      })), _react2["default"].createElement('div', null, _react2["default"].createElement(ToolbarButton, {
        id: 'delete',
        onClick: this.handleDelete,
        disabled: !selected && !drawing,
        keyName: (0, _util.getKeyName)(this.context, this.keymap, 'delete'),
        title: translate('delete', 'Delete')
      }), _react2["default"].createElement(ToolbarButton, {
        id: 'reset',
        onClick: this.handleReset,
        disabled: !spans.length && !origSpans.length,
        keyName: (0, _util.getKeyName)(this.context, this.keymap, 'reset'),
        title: translate('reset', 'Reset')
      }))));

      return _react2["default"].createElement(_react.Fragment, null, _react2["default"].createElement(_shared.Heading, {
        toolbar: toolbar,
        classes: {
          _root: classes.heading
        },
        hasLabels: true
      }, _react2["default"].createElement(LabelComponent, {
        labels: labels,
        selected: label,
        handleSelect: this.handleLabelSelect,
        keymap: config.labelKeymap
      })), _react2["default"].createElement(_shared.Content, {
        className: classes.content
      }, _react2["default"].createElement('div', {
        className: classes.wrapper,
        ref: function ref(x) {
          _this4.content = x;
        }
      }, _react2["default"].createElement(_reactKonva.Stage, {
        className: classes.stage,
        scaleX: scale,
        scaleY: scale,
        width: width,
        height: height,
        onMouseDown: this.handleMouseDown,
        onMouseMove: this.handleMouseMove,
        onMouseUp: this.handleMouseUp,
        onDblClick: this.handleClosePoints,
        onTouchStart: this.handleMouseDown,
        onTouchMove: this.handleMouseMove,
        onTouchEnd: this.handleMouseUp,
        onDblTap: this.handleClosePoints,
        style: {
          cursor: this.getCursor()
        }
      }, _react2["default"].createElement(_reactKonva.Layer, {
        ref: function ref(x) {
          _this4.layer = x;
        }
      }, _react2["default"].createElement(_reactKonva.Rect, {
        x: 0,
        y: 0,
        fill: '#000',
        width: width,
        height: height,
        listening: false
      }), _react2["default"].createElement(URLImage, {
        src: content.image,
        x: 0,
        y: 0,
        opacity: darkenOpacity,
        onLoad: this.handleImageLoad
      }), sortedSpans.map(function (span) {
        return _react2["default"].createElement(_reactKonva.Group, {
          key: span.id,
          name: 'shape',
          id: span.id,
          onMouseDown: function onMouseDown() {
            return _this4.selectSpan(span);
          },
          onMouseOver: function onMouseOver() {
            return _this4.setState({
              hover: span.id
            });
          },
          onMouseOut: function onMouseOut() {
            return _this4.setState({
              hover: null
            });
          },
          onTouchStart: function onTouchStart() {
            return _this4.selectSpan(span);
          }
        }, _react2["default"].createElement(Shape, _extends({
          span: span,
          ref: function ref(x) {
            _this4.spans[span.id] = x;
          },
          draggable: true,
          listening: selected === span.id || selectKey,
          closed: true,
          isSelected: selected === span.id,
          showPoints: isTransforming !== span.id && isDragged !== span.id && selected === span.id
        }, shapeProps), span.id == selected && _react2["default"].createElement(_reactKonva.Transformer, _extends({
          ref: function ref(x) {
            _this4.trf = x;
          },
          borderStroke: span.color,
          anchorFill: span.color
        }, transformerProps, {
          borderEnabled: span.type !== 'rect',
          anchorSize: span.type === 'rect' ? strokeWidth * 2.5 : strokeWidth * 2,
          onTransformStart: _this4.handleTrfStart(span),
          onTransformEnd: _this4.handleTrfEnd(span)
        }))));
      }), sortedSpans.map(function (span) {
        return showLabels && isTransforming !== span.id && isDragged !== span.id && _react2["default"].createElement(ShapeLabel, _extends({
          key: span.id,
          span: span,
          onMouseOver: function onMouseOver() {
            _this4.setState({
              hover: span.id
            });
          },
          onMouseOut: function onMouseOut() {
            return _this4.setState({
              hover: null
            });
          },
          onMouseDown: _this4.handleSelectSpan(span),
          onTouchStart: _this4.handleSelectSpan(span),
          listening: !drawing && selected !== span.id
        }, shapeLabelProps));
      }), !!Object.keys(current).length && _react2["default"].createElement(Shape, _extends({
        span: current,
        ref: function ref(x) {
          _this4.current = x;
        },
        listening: false,
        isDrawn: true
      }, shapeProps)))))));
    }
  }]);

  return ImageManual;
}(_react2["default"].Component), _class3.id = 'image_manual', _class3.defaultProps = {
  ToolbarButton: _Toolbar.ToolbarButton,
  minWidth: 650,
  anchorSize: 8,
  config: {}
}, _class3.contextTypes = {
  shortcuts: _propTypes2["default"].object
}, _temp3)) || _class2);